import React, {useCallback, useState} from "react";
import {Checkbox, notification, Popover, Space, Tooltip} from "antd";
import Button from "@mui/material/Button";

const TimeseriesMenu = ({ allTickers, selectedTickers, setSelectedTickers, onPlotHoldings, warn=false }) => {
    const [visible, setVisible] = useState(false);
    const handleVisibleChange = (newVisible) => setVisible(newVisible);

    const handleTickerChange = useCallback((checkedValues) => {
        setSelectedTickers(checkedValues);
        onPlotHoldings(checkedValues);  // Update the plot holdings directly based on checked values
        if (checkedValues.length === 0) {
            notification.warning({
                message: 'No tickers selected',
                description: 'Select tickers to plot or plot all by default.',
                duration: 5
            });
        }
    }, [setSelectedTickers, onPlotHoldings]);

    const tickerOptions = allTickers.map(ticker => ({ label: ticker.symbol, value: ticker.symbol }));
    const content = (
        <Checkbox.Group
            style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)' }}
            options={tickerOptions}
            value={selectedTickers}
            onChange={handleTickerChange}
        />
    );

    return (
        <>
            <Popover
                content={content}
                title="Select Tickers"
                trigger="click"
                visible={visible}
                onVisibleChange={handleVisibleChange}
            >
                <Tooltip title={'Add / Remove Portfolio Holdings From Plot'}>
                    <Button size={'small'} variant={'outlined'} color={selectedTickers.length===0 && warn ?'error':'primary'}>
                        {selectedTickers.length} / {allTickers.length} Holdings
                    </Button>
                </Tooltip>
            </Popover>
        </>
    );
};

export default TimeseriesMenu;